module.exports = __webpack_public_path__ + "static/media/agricultural3.76ffb4a7.jpg";